function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 342 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154605",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5969",
    d: "M140.882-803.84v-6.377h18.235v6.377h-1.765v-4.638h-14.705v4.638zm.59-7.916a1.432 1.432 0 0 1-1.042-.421 1.387 1.387 0 0 1-.43-1.023 1.391 1.391 0 0 1 .429-1.027 1.426 1.426 0 0 1 1.041-.424 1.433 1.433 0 0 1 1.042.423 1.386 1.386 0 0 1 .43 1.025 1.393 1.393 0 0 1-.429 1.027 1.425 1.425 0 0 1-1.041.42zm3.1-.066v-9.922a2.006 2.006 0 0 1 .625-1.48 2.063 2.063 0 0 1 1.5-.615h6.603a2.063 2.063 0 0 1 1.5.615 2.005 2.005 0 0 1 .625 1.48v9.922zm13.96.066a1.431 1.431 0 0 1-1.042-.421 1.386 1.386 0 0 1-.43-1.026 1.391 1.391 0 0 1 .428-1.027 1.427 1.427 0 0 1 1.041-.424 1.434 1.434 0 0 1 1.042.423 1.386 1.386 0 0 1 .43 1.025 1.392 1.392 0 0 1-.428 1.027 1.425 1.425 0 0 1-1.042.423zm-12.2-1.806h7.331v-8.183a.343.343 0 0 0-.1-.256.353.353 0 0 0-.26-.1H146.7a.353.353 0 0 0-.26.1.343.343 0 0 0-.1.256zm0 0z",
    transform: "translate(-138 825.84)",
    style: {
      fill: "#121212"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMSeat);
export default __webpack_public_path__ + "static/media/m_seat.9d13b14197b3a990486cea4d94b7e483.svg";
export { ForwardRef as ReactComponent };